import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getInvoicesSuccess, getInvoicesFailure,
    getInvoiceByIdSuccess, getInvoiceByIdFailure,
    addPaymentSuccess, addPaymentFailure,
    cancelInvoiceSuccess, cancelInvoiceFailure,
    updateLineItemsSuccess, updateLineItemsFailure,
    applyVoucherSuccess, applyVoucherFailure,
    removeVoucherSuccess, removeVoucherFailure,
    setVoucherSerialSuccess, setVoucherSerialFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

const API_BASE = process.env.REACT_APP_SERVER_API;

function getAuthHeaders(branchId) {
    const token = localStorage.getItem("item");
    return {
        "Authorization": token,
        "Content-Type": "application/json",
        "X-Current-Branch": branchId,
    };
}

function* getInvoices(action) {
    try {
        const token = localStorage.getItem("item");
        if (!token) { yield put(logoutRequest()); return; }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const params = action.payload || {};
        const queryString = new URLSearchParams(params).toString();

        const response = yield call(requestHandler, `${API_BASE}api/invoices?${queryString}`, {
            method: "GET",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(getInvoicesSuccess(response));
    } catch (error) {
        yield put(getInvoicesFailure(error?.response?.message || error));
    }
}

function* getInvoiceById(action) {
    try {
        const token = localStorage.getItem("item");
        if (!token) { yield put(logoutRequest()); return; }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${action.payload}`, {
            method: "GET",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(getInvoiceByIdSuccess(response));
    } catch (error) {
        yield put(getInvoiceByIdFailure(error?.response?.message || error));
    }
}

function* addPayment(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, ...data } = action.payload;
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${id}/payment`, {
            method: "POST",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify(data),
        });
        yield put(addPaymentSuccess(response));
    } catch (error) {
        yield put(addPaymentFailure(error?.response?.message || error));
    }
}

function* cancelInvoice(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${action.payload}/cancel`, {
            method: "PUT",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(cancelInvoiceSuccess(response));
    } catch (error) {
        yield put(cancelInvoiceFailure(error?.response?.message || error));
    }
}

function* updateLineItems(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, ...data } = action.payload;
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${id}/line-items`, {
            method: "PUT",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify(data),
        });
        yield put(updateLineItemsSuccess(response));
    } catch (error) {
        yield put(updateLineItemsFailure(error?.response?.message || error));
    }
}

function* applyVoucher(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, code } = action.payload;
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${id}/apply-voucher`, {
            method: "POST",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify({ code }),
        });
        yield put(applyVoucherSuccess(response));
    } catch (error) {
        yield put(applyVoucherFailure(error?.response?.message || error));
    }
}

function* removeVoucher(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${action.payload}/voucher`, {
            method: "DELETE",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(removeVoucherSuccess(response));
    } catch (error) {
        yield put(removeVoucherFailure(error?.response?.message || error));
    }
}

function* setVoucherSerial(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, voucherSerialNo } = action.payload;
        const response = yield call(requestHandler, `${API_BASE}api/invoices/${id}/voucher-serial`, {
            method: "PUT",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify({ voucherSerialNo }),
        });
        yield put(setVoucherSerialSuccess(response));
    } catch (error) {
        yield put(setVoucherSerialFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('invoice/getInvoicesRequest', getInvoices);
    yield takeLatest('invoice/getInvoiceByIdRequest', getInvoiceById);
    yield takeLatest('invoice/addPaymentRequest', addPayment);
    yield takeLatest('invoice/cancelInvoiceRequest', cancelInvoice);
    yield takeLatest('invoice/updateLineItemsRequest', updateLineItems);
    yield takeLatest('invoice/applyVoucherRequest', applyVoucher);
    yield takeLatest('invoice/removeVoucherRequest', removeVoucher);
    yield takeLatest('invoice/setVoucherSerialRequest', setVoucherSerial);
}

export default saga;
